import RCTooltip from "rc-tooltip";
import "rc-tooltip/assets/bootstrap_white.css";
import { CSSProperties, PropsWithChildren, ReactNode, useState } from "react";
import "./Tooltip.scss";

export interface TooltipProps {
    overlay: ReactNode;
    isHidden?: boolean;
    placement?: "bottom" | "top" | "left" | "right" | "bottomLeft" | "bottomRight";
    overlayClassName?: string;
    overlayStyle?: CSSProperties;
    align?: { offset?: number[]; points?: string[]; targetOffset?: number[] };
    trigger?: any[];
    hideOnWheel?: boolean;
    showArrow?: boolean;
    triggerClassName?: string;
}

type TooltipWithChildrenProps = PropsWithChildren<TooltipProps>;

const Tooltip = ({
    overlay,
    isHidden,
    children,
    placement,
    overlayClassName,
    overlayStyle = {},
    align = {},
    trigger,
    hideOnWheel,
    showArrow = true,
    triggerClassName,
}: TooltipWithChildrenProps) => {
    const [visible, setVisible] = useState(false);
    const onVisibleChange = (visible: boolean) => !isHidden && setVisible(visible);

    const overlayWrapper = hideOnWheel ? (
        <div onWheel={() => setVisible(false)}>{overlay}</div>
    ) : (
        overlay
    );

    return (
        <RCTooltip
            overlay={overlayWrapper}
            placement={placement ?? "bottom"}
            visible={visible}
            arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
            onVisibleChange={onVisibleChange}
            overlayClassName={overlayClassName}
            overlayStyle={overlayStyle}
            align={align}
            trigger={trigger}
            showArrow={showArrow}
        >
            <span
                onClick={() => setVisible(false)}
                className={
                    triggerClassName
                        ? `tooltipTrigger ${triggerClassName}`
                        : "tooltipTrigger"
                }
            >
                {children}
            </span>
        </RCTooltip>
    );
};

export default Tooltip;
